import React from 'react';
import { Box, Typography } from '@mui/material';
import UsageLimitDisplay from './UsageLimitDisplay';
import { getPlanLimit } from '../../utils/planUtils';

export default function UsageLimitCard({ currentUsage, planType, onUpgrade }) {
    const limit = getPlanLimit(planType);
    const remaining = Math.max(0, limit - currentUsage);
    const percentage = Math.min(100, (currentUsage / limit) * 100);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, textAlign: 'center' }}>
                Total Chats (Month to Date)
            </Typography>
            <UsageLimitDisplay
                currentUsage={currentUsage}
                limit={limit}
                percentage={percentage}
                remaining={remaining}
                planType={planType}
                showUpgradeButton={true}
                onUpgrade={onUpgrade}
            />
        </Box>
    );
}
